import React from "react";

const ErrorMessage = () => {
  return (
    <div className="d-flex">
      <div className="d-flex flex-column align-items-center mt-4">
        <h1 style={{ fontSize: "70px" }}>
          <i className="fa-solid fa-circle-exclamation mb-4"></i>
        </h1>
        <p
          className="bg-light p-2 rounded-pill fw-bolder"
          style={{ translate: "0px -20px" }}
        >
          Nenhuma Informação Encontrada
        </p>
      </div>
    </div>
  );
};

export default ErrorMessage;
